export default __webpack_public_path__ + "static/media/CommercialListing.5e20201c.svg";